import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  standalone: true
})
export class SkeletonComponent {
  numberOfRows = new Array(15);
  numberOfCells = new Array(7);
}
